/** ----------------------------------------
    Modules
 ---------------------------------------- */

import { ScrollTo } from '@js/module/ScrollTo.js';

/** ----------------------------------------
     Menu
 ---------------------------------------- */

import { MenuNavigation } from '@js/module/Menu.js';
const menu = new MenuNavigation(false);

/* ----------------------------------------
    Utilites
---------------------------------------- */

import * as dom from '@util/dom';

/* ----------------------------------------
    Navigation Anchors
---------------------------------------- */

export class StickyAnchors {

    constructor() {
        this._clone = null;
        this._init();
    }

    /** ----------------------------------------
         Sticky
     ---------------------------------------- */

    _setStickyBar() {
        const clone = this._anchors.cloneNode(true);
        clone.classList.add('is-sticky');
        this._anchors.insertAdjacentHTML('afterend', clone.outerHTML);
        this._clone = document.querySelector('.is-sticky');

        const hamburger = this._clone.querySelector('.nav__hamburger');
        menu.addToggleEvent(hamburger);

        this._progressBar = this._clone.querySelector('.nav__progress');
        this._links = this._clone && this._clone.querySelectorAll('.nav__link');
    }

    _removeStickyBar() {
        const hamburger = this._clone.querySelector('.nav__hamburger');
        menu.destroyToggleEvent(hamburger);

        const item = document.querySelector('.is-sticky');
        item.remove();
        this._clone = null;
    }

    /** ----------------------------------------
         Progress
     ---------------------------------------- */

    _progress(bounding) {
        const documentHeight = document.body.offsetHeight;
        const anchorsOffset = this._anchors.offsetTop;

        const scrolled = window.scrollY - anchorsOffset;
        const remainder = documentHeight - anchorsOffset - window.innerHeight;

        const percentage = Math.round((scrolled / remainder) * 10000) / 100;

        if(percentage > 0) this._progressBar.style.width = percentage + '%';
    }

    /** ----------------------------------------
         Anchors
     ---------------------------------------- */

    _createAnchors(type) {
        const anchors = this['_' + type].querySelectorAll('.js-scroll');
        [...anchors].forEach(anchor => new ScrollTo(anchor, 1500));
    }

    _setAnchorIds() {
        const anchors = this._anchors.querySelectorAll('.js-scroll');
        const ids = [...anchors].map(anchor => anchor.href.split('#').pop());

        this._ids = ids.map(id => {
            const el = document.querySelector('#' + id);
            if(!el) return;

            return {
                el: el,
                id: id,
                offset: el.offsetTop - (window.innerHeight / 5)
            }
        });
    }

    _scrolledId() {
        const passed = this._ids.filter(id => id.offset < window.scrollY);
        this._setActiveAnchor(passed);
    }

    _setActiveAnchor(passed) {
        passed.length && passed.forEach(anchor => {
            [...this._links].forEach(link => {
                link.dataset.name === anchor.id ? link.classList.add('is-active') : link.classList.remove('is-active');
            })
        });
    }

    /** ----------------------------------------
        Next
     ---------------------------------------- */

    _createNextPlaceholder() {
        this._nextCase.style.transform = 'translateY(100%)';

        const height = this._nextCase.offsetHeight;
        const placeholder = document.createElement('div');

        dom.style(placeholder, {
            width: '100%',
            height: dom.unit(height)
        });

        this._nextCase.insertAdjacentHTML('afterend', placeholder.outerHTML);
    }

    _next() {
        const scrolled = window.scrollY + window.innerHeight;
        const nextOffset = this._contact.offsetTop + this._contact.offsetHeight;
        const nextScrolled = scrolled - nextOffset;
        const opacityLevel = 1 / this._nextCase.offsetHeight;

        if(nextScrolled >= 0) {
            const level = nextScrolled * opacityLevel;
            this._contactShadow.style.opacity = level;
            this._nextCase.style.opacity = level;

            dom.style(this._nextCase, {
                transform: `translateY(${ dom.unit(300 - (200 * (level * 1.5))) })`
            });
        } else {
            this._contactShadow.style.opacity = 0;
            this._nextCase.style.opacity = 0;
        }
    }

    /** ----------------------------------------
        Events
     ---------------------------------------- */

    _event() {
        window.addEventListener('scroll', e => {
            const bounding = this._anchors.getBoundingClientRect();
            const top = Math.sign(bounding.top);

            if(this._clone === null && top < 0) {
                this._setStickyBar();
                this._createAnchors('clone');

                this._mainNav.classList.add('is-white');
                this._mainNav.style.zIndex = 10000;
                this._menu.style.zIndex = 10000;
            }

            if(this._clone !== null && top >= 0) {
                this._removeStickyBar();

                this._mainNav.classList.remove('is-white');
                this._mainNav.style.zIndex = 1000000;
                this._menu.style.zIndex = 10000;
            }

            // this._scrolledId();
            this._progress(bounding);
            this._next();
        });
    }

    /** ----------------------------------------
        Initialize
     ---------------------------------------- */

    _init() {
        this._mainNav = document.querySelector('.nav--main');
        this._nav = document.querySelector('.nav--sticky');
        this._menu = document.querySelector('.menu');
        this._anchors = document.querySelector('.nav--anchors');
        this._contact = document.querySelector('.contact');
        this._contactShadow = this._contact.querySelector('.contact__shadow');
        this._nextCase = document.querySelector('.next');

        this._event();
        this._createAnchors('anchors');
        // this._setAnchorIds();

        this._createNextPlaceholder();
        this._next();
    }

}
